// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".utility-bar[data-v-33a3f905]{position:relative;background-color:var(--utility-bar-background-color);box-shadow:0 -1px grey;width:100%}.utility-bar[data-v-33a3f905],ul[data-v-33a3f905]{height:100%;display:flex;align-items:center;align-content:center}ul[data-v-33a3f905]{list-style:none;margin:0;padding:0 10px}", ""]);
// Exports
module.exports = exports;
